// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"1f53c128","453":"a236ae8f"}[chunkId] + ".chunk.js";
};